import { FetchArgs, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';

import axios from 'axios';

/**
 * On Production user "vchasno-auth" stored in cookies and set from .vchasno.ua domain, httponly=true, secure
 */
export const internalApiClient = axios.create({
  baseURL: '/api/internal',
  xsrfCookieName: 'xsrf',
  xsrfHeaderName: 'X-XSRF-Token',
  withCredentials: true,
});

const SKIP_RETRY: number[] = [400, 401, 403, 422];

export const staggeredBaseQueryWithBailOut = retry(
  async (args: string | FetchArgs, api, extraOptions) => {
    const result = await fetchBaseQuery({
      baseUrl: '/',
      credentials: 'include',
      headers: {
        xsrfCookieName: 'xsrf',
        xsrfHeaderName: 'X-XSRF-Token',
      },
    })(args, api, extraOptions);

    if (SKIP_RETRY.includes(Number(result.error?.status))) {
      retry.fail(result.error);
    }

    return result;
  },
  {
    maxRetries: 2,
  },
);
